import React from "react";

const NoRoute = () => {
  return (
    <div className="no-route">
      <p>Oops!!! 404</p>
    </div>
  );
};

export default NoRoute;
